export default __webpack_public_path__ + "images/a0135b664d66d24ee1169e0f60d624d6-pop_music_small.webp";